import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=c9b5a6e8&scoped=true&"
import script from "./TeamList.vue?vue&type=script&lang=ts&"
export * from "./TeamList.vue?vue&type=script&lang=ts&"
import style0 from "./TeamList.vue?vue&type=style&index=0&id=c9b5a6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b5a6e8",
  null
  
)

export default component.exports